/*
  NOURION IT Notfall Seite (sections/nrn-notfall.liquid), Kerem 15.10.2026. Fortschreitende Verbesserung: ohne dieses
  Skript bleibt alles bedienbar (Telefonlinks, echte Checkboxen, Formular, statischer Zeitstrahl, Leiste sichtbar).

  1. Status: Kurz und Langtext aus den Einstellungen (data-text-*), [wann] wird zu "heute ab 8 Uhr" usw.
     Zeitlogik in assets/nrn-notfall-zeit.js (window.NrnNotfallZeit). Der Status wird nicht nur beim Laden gesetzt:
     die Zeitlogik ruft ihre Beobachter zu jeder vollen Minute, beim Zurueckkommen in den Tab und nach dem Back
     Forward Cache, dann schreibt status() Attribut und Texte neu (16.10.2026: vorher stand um 18:30 noch
     "Jetzt erreichbar", wenn die Seite um 17:55 geoeffnet wurde).
  2. Nummer kopieren, nur mit Zwischenablage und sicherem Kontext.
  3. Checkliste: Fortschritt "[x] von [n] erledigt" als aria-live, Ring im CSS ueber --anteil; Haken bleiben in der
     Sitzung (sessionStorage in try/catch, ohne Speicher nur fuer die Seite).
  4. Zeitstrahl: das rote Licht laeuft einmal, sobald der Ablauf sichtbar wird (nicht bei reduzierter Bewegung).
  5. Handy Leiste: sichtbar, solange der Anrufknopf der Direktwahl nicht ganz frei zu sehen ist. Frei heisst: komplett
     zwischen dem Dock oben und der Zone der Leiste unten. Vorher reichte ein angeschnittener Rand der Direktwahl, dann
     blieb die Leiste bei 360 mal 740 verborgen, obwohl "Jetzt anrufen" unter der Falz lag (QA 15.10.2026).
  Keine sichtbaren Texte im Code; alles kommt aus Datenattributen der Sektion.
*/
(() => {
  'use strict';

  const SPEICHER = 'nrn-notfall-haken';
  const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const lesen = () => {
    try {
      const roh = window.sessionStorage.getItem(SPEICHER);
      const liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      return [];
    }
  };

  const schreiben = (liste) => {
    try {
      window.sessionStorage.setItem(SPEICHER, JSON.stringify(liste));
    } catch (e) {
      /* Speicher gesperrt (privates Fenster): Haken gelten nur fuer diese Seite */
    }
  };

  const ersetze = (vorlage, werte) =>
    String(vorlage || '').replace(/\[(\w+)\]/g, (ganz, name) => (name in werte ? String(werte[name]) : ganz));

  /* Nur schreiben, wenn sich der Wert aendert: der Minutentakt soll das DOM nicht jede Minute anfassen */
  const textSetzen = (el, wert) => {
    if (el.textContent !== wert) el.textContent = wert;
  };
  const versteckenSetzen = (el, wert) => {
    if (el.hidden !== wert) el.hidden = wert;
  };

  /* ---- 1. Status ---- */
  const status = (wurzel) => {
    if (!window.NrnNotfallZeit) return;
    const d = wurzel.dataset;
    const [von, bis] = (d.nrnZeiten || '8-18').split('-').map(Number);
    const lage = window.NrnNotfallZeit.lage(von, bis);
    wurzel.setAttribute('data-nrn-besetzt', lage.besetzt ? 'ja' : 'nein');

    let kurz = d.textBesetzt || '';
    let lang = d.textZeiten || '';
    if (!lage.besetzt) {
      const wannVorlage = lage.wann === 'heute' ? d.textHeute : lage.wann === 'morgen' ? d.textMorgen : d.textTag;
      const wann = ersetze(wannVorlage, { von: lage.ab, tag: lage.tag || '' });
      kurz = d.textFrei || '';
      lang = ersetze(d.textWieder, { wann });
    }
    wurzel.querySelectorAll('[data-nrn-status-kurz]').forEach((el) => {
      textSetzen(el, kurz);
      versteckenSetzen(el, !kurz);
    });
    wurzel.querySelectorAll('[data-nrn-status-lang]').forEach((el) => {
      textSetzen(el, lang);
    });
    const text = wurzel.querySelector('[data-nrn-formular-text]');
    if (text && text.dataset.nrnTextUnbesetzt) {
      /* Urtext einmal merken, damit der Wechsel zurueck zu besetzt (Minutentakt um 8 Uhr) ihn wieder zeigt */
      if (!('nrnTextBesetzt' in text.dataset)) text.dataset.nrnTextBesetzt = text.textContent;
      textSetzen(text, lage.besetzt ? text.dataset.nrnTextBesetzt : text.dataset.nrnTextUnbesetzt);
    }
  };

  /* ---- 2. Nummer kopieren ---- */
  const kopieren = (wurzel) => {
    const knopf = wurzel.querySelector('[data-nrn-kopieren]');
    const meldung = wurzel.querySelector('[data-nrn-kopieren-status]');
    if (!knopf || !navigator.clipboard || !window.isSecureContext) return;
    knopf.hidden = false;
    const beschriftung = knopf.querySelector('[data-nrn-kopieren-text]');
    const vorher = beschriftung ? beschriftung.textContent : '';
    let uhr = 0;
    knopf.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(knopf.dataset.nrnNummer || '');
        if (beschriftung) beschriftung.textContent = knopf.dataset.nrnKopiert || vorher;
        knopf.classList.add('is-kopiert');
        if (meldung) meldung.textContent = (knopf.dataset.nrnKopiert || '') + ': ' + (knopf.dataset.nrnNummer || '');
        window.clearTimeout(uhr);
        uhr = window.setTimeout(() => {
          if (beschriftung) beschriftung.textContent = vorher;
          knopf.classList.remove('is-kopiert');
        }, 2400);
      } catch (e) {
        if (meldung) meldung.textContent = knopf.dataset.nrnFehler || '';
      }
    });
  };

  /* ---- 3. Checkliste ---- */
  const checkliste = (wurzel) => {
    const felder = Array.from(wurzel.querySelectorAll('[data-nrn-haken]'));
    const anzeige = wurzel.querySelector('[data-nrn-fortschritt]');
    if (!felder.length) return;
    const text = anzeige ? anzeige.querySelector('[data-nrn-fortschritt-text]') : null;
    const gespeichert = lesen();
    felder.forEach((f) => {
      if (gespeichert.includes(f.dataset.nrnHaken)) f.checked = true;
    });

    const zeigen = (ansagen) => {
      const n = felder.length;
      const x = felder.filter((f) => f.checked).length;
      if (anzeige) {
        anzeige.hidden = false;
        anzeige.style.setProperty('--anteil', String(x / n));
        anzeige.setAttribute('data-fertig', x === n ? 'ja' : 'nein');
      }
      if (text) {
        const neu = x === n && anzeige.dataset.textFertig ? anzeige.dataset.textFertig : ersetze(anzeige.dataset.textFortschritt, { x, n });
        /* Beim Laden still setzen, damit der Screenreader nicht sofort spricht; danach ueber aria-live */
        if (!ansagen) text.setAttribute('aria-live', 'off');
        text.textContent = neu;
        if (!ansagen) window.setTimeout(() => text.setAttribute('aria-live', 'polite'), 0);
      }
    };

    felder.forEach((f) =>
      f.addEventListener('change', () => {
        schreiben(felder.filter((x) => x.checked).map((x) => x.dataset.nrnHaken));
        zeigen(true);
      })
    );
    zeigen(false);
  };

  /* ---- 4. Zeitstrahl: Licht laeuft einmal ---- */
  const zeitstrahl = (wurzel) => {
    const ablauf = wurzel.querySelector('[data-nrn-ablauf]');
    if (!ablauf || ruhig() || !('IntersectionObserver' in window)) return;
    ablauf.setAttribute('data-nrn-licht', 'bereit');
    const io = new IntersectionObserver(
      (eintraege) => {
        eintraege.forEach((e) => {
          if (!e.isIntersecting) return;
          ablauf.setAttribute('data-nrn-licht', 'an');
          io.disconnect();
        });
      },
      { rootMargin: '0px 0px -18% 0px', threshold: 0.35 }
    );
    io.observe(ablauf);
  };

  /* ---- 5. Handy Leiste, solange der Anrufknopf der Direktwahl nicht wirklich sichtbar ist ---- */
  /* Oben deckt das klebende Dock rund 70 px, unten liegt die Leiste in den letzten rund 80 px. Nur wenn der Knopf
     innerhalb dieser Raender fast ganz (98 %) zu sehen ist, verschwindet die Leiste; sonst bleibt ein Anrufknopf da. */
  const LEISTE_RAND = '-72px 0px -96px 0px';
  const leiste = (wurzel) => {
    const wahl = wurzel.querySelector('[data-nrn-wahl]');
    if (!wahl || !wurzel.querySelector('[data-nrn-leiste]') || !('IntersectionObserver' in window)) return;
    const ziel = wahl.querySelector('[data-nrn-wahl-aktion]') || wahl;
    const io = new IntersectionObserver(
      (eintraege) => {
        eintraege.forEach((e) => {
          const frei = e.isIntersecting && e.intersectionRatio >= 0.98;
          wurzel.setAttribute('data-nrn-leiste-zeigen', frei ? 'nein' : 'ja');
        });
      },
      { rootMargin: LEISTE_RAND, threshold: [0, 0.98] }
    );
    io.observe(ziel);
  };

  /* Eingerichtete Sektionen, damit der Minutentakt ihren Status neu schreiben kann */
  const wurzeln = new Set();

  const starten = (bereich) => {
    if (!bereich || !bereich.querySelectorAll) return;
    const neue = bereich.matches && bereich.matches('[data-nrn-notfall]') ? [bereich] : Array.from(bereich.querySelectorAll('[data-nrn-notfall]'));
    neue.forEach((wurzel) => {
      if (wurzel.dataset.nrnBereit === 'ja') return;
      wurzel.dataset.nrnBereit = 'ja';
      wurzeln.add(wurzel);
      status(wurzel);
      kopieren(wurzel);
      checkliste(wurzel);
      zeitstrahl(wurzel);
      leiste(wurzel);
    });
  };

  starten(document);
  /* Zeitlogik meldet jeden neuen Stand (volle Minute, Tab wieder sichtbar, Back Forward Cache): Status neu schreiben */
  if (window.NrnNotfallZeit && typeof window.NrnNotfallZeit.beobachten === 'function') {
    window.NrnNotfallZeit.beobachten(() => wurzeln.forEach(status));
  }
  document.addEventListener('shopify:section:load', (e) => starten(e.target));
  document.addEventListener('shopify:section:unload', () => {
    wurzeln.forEach((wurzel) => {
      if (!wurzel.isConnected) wurzeln.delete(wurzel);
    });
  });
})();
